import { mapGetters, mapActions } from "vuex";

export default class ApiMixinFactory {

    constructor() {
    }


    functionifyName(prefix, name) {
        return prefix.toLowerCase() + name.slice(0, 1).toUpperCase() + name.slice(1);
    }
    actionifyName(name) {
        return {
            get: this.functionifyName("get", name),
            set: this.functionifyName("set", name),
            global: this.functionifyName("global", name),
        }
    }
    functionifyFriendlyName(prefix, name) {
        return `store${prefix.slice(0, 1).toUpperCase()}${prefix.slice(1)}${name}`;
    }

    generateMixin(config, namespace = null)
    {

        var ret = {
            "computed": {},
            "methods": {}
        };
        // debugger;
        config.forEach(e => {
            var funcName = this.actionifyName(e.name);
            var getter = mapGetters([funcName.get]);
            var setter = mapActions([funcName.set]);
            ret.computed[funcName.global] = {
                get: getter[funcName.get],
                set: setter[funcName.set],
            }
        });

        return ret;

    }

    generateVuexModule(config) {
        let state = {};
        let getters = {};
        let mutations = {};
        let actions = {};
        config.forEach(e => {

            const getFuncName = this.functionifyName("get", e.name);
            const setFuncName = this.functionifyName("set", e.name);

            const getFriendlyFuncName = this.functionifyName("get", e.name);
            const setFriendlyFuncName = this.functionifyName("set", e.name);
            state[e.name] = !!e.get
                ? typeof (e.get) == typeof (() => { })
                    ? e.get()
                    : e.get
                : null;

            getters[getFriendlyFuncName] = (state) => {
                var result = state[e.name];
                return result;
            };
            getters[getFuncName] = getters[getFriendlyFuncName];

            mutations[setFriendlyFuncName] = (state, value) => {
                (state[e.name] = value)
            };
            mutations[getFuncName] = mutations[setFriendlyFuncName];

            actions[setFuncName] = ({ commit }, value) => {
                e.set ? e.set(value) : false;
                commit(setFriendlyFuncName, value);
            };
            actions[setFuncName] = actions[setFriendlyFuncName];
        })

        var ret = {
            state,
            getters,
            mutations,
            actions,
        };
        // debugger;
        return ret;
    }


    generateVuexNamespacedMixin(_config, namespace) {
        var ret = {
            "computed": {},
            "methods": {}
        };
        var config = Object.keys(_config).map(e => Object.assign(_config[e], { name : e }));
        config.forEach(e => {
            var key = `${namespace}_${e.name}`;
            var funcNames = this.actionifyName(key);
            var getter = mapGetters([funcNames.get]);
            var setter = mapActions([funcNames.set]);
            var computedName = `${namespace}_${e.name}`;
            ret.computed[computedName] = {
                get: getter[funcNames.get],
                set: setter[funcNames.set],
            };
        })
        return ret;
    }

    generateVuexNamespacedModule(_config, namespace)
    {
        if(!_config){ return null; }

        let state = {};
        let getters = {};
        let mutations = {};
        let actions = {};
        let bindings = [];

        var config = Object.keys(_config).map(e => {return Object.assign({ name : e }, _config[e]); })

        config.forEach(e => {

            var key = `${namespace}_${e.name}`;

            var actionNames = this.actionifyName(key);

            const getFuncName = actionNames.get;
            const setFuncName = actionNames.set;

            state[key] = !!e.storageMode && !!e.storageMode.getter && typeof (e.storageMode.getter) == typeof (() => { }) && e.storageMode.getter(e.name)
                    ? e.storageMode.getter(e.name)
                    : e.default;

            getters[getFuncName] = (state) => {
                var result = state[key];
                return result;
            };

            mutations[setFuncName] = (state, value) => {
                (state[key] = value)
            };

            actions[setFuncName] = ({ commit }, value) => {
                if(!!e.storageMode)
                {
                    e.storageMode.setter(e.name, value)
                }
                commit(setFuncName, value);
            };
  
        });

        var ret = {
            state,
            getters,
            mutations,
            actions,
        };

        // console.log("ret =>", ret);

        return ret;
    }
}
